<div class="user-info-container">
    <h1>{{ 'Enter the below Information' | translate }}</h1>
     <form [formGroup]="Form" (ngSubmit)="onSubmit()" autocomplete="off">
        <div>
            <div class="col">
                <mat-form-field class="full-width" appearance="outline">
                    <mat-label>{{ 'Email' | translate }}</mat-label>
                    <input matInput type="email"
                    formControlName="email" 
                    autocomplete="off">
                </mat-form-field>
            </div>
            <div class="col">
                <mat-form-field class="full-width" appearance="outline">
                    <mat-label>{{ 'Phone(optional)' | translate }}</mat-label>
                    <input matInput type="number"
                    formControlName="phone">
                </mat-form-field>
            </div>
        </div>
        <div mat-dialog-actions>
            <button mat-stroked-button [disabled]="fetching || !Form.valid" color="primary">
                <ng-container *ngIf="!fetching">{{ 'Submit' | translate }}</ng-container>
                <mat-spinner *ngIf="fetching" diameter="20"></mat-spinner>
            </button>

            <button mat-stroked-button color="warn" (click)="onNoClick()">{{ 'No Thanks' | translate }}</button>
        </div>
     </form>
</div>
